import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AmparoBio from './components/AmparoBio';
import HomeCtaBanner from './components/HomeCtaBanner';
import SEO from '@/components/feature/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://floridahousesforsale.deals';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Florida Homes for Sale',
    url: SITE_URL,
    description: 'Florida real estate listings and homes for sale with Amparo Jarquin, licensed REALTOR® serving all of Florida.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/listings?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    name: 'Amparo Jarquin',
    url: SITE_URL,
    logo: `${SITE_URL}/vite.svg`,
    image: 'https://public.readdy.ai/ai/img_res/dcc06f628c3cc16a5ecb0484948a2f4d.jpg',
    description: 'Licensed REALTOR® Amparo Jarquin specializes in Florida homes for sale, serving buyers and sellers across all of Florida.',
    telephone: '+17726268544',
    email: 'pslucie369@gmail.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'West Palm Beach',
      addressLocality: 'West Palm Beach',
      addressRegion: 'FL',
      postalCode: '33406',
      addressCountry: 'US',
    },
    areaServed: {
      '@type': 'State',
      name: 'Florida',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '16:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Saturday'],
        opens: '10:00',
        closes: '16:00',
      },
    ],
    sameAs: [],
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SEO
        title="Florida Homes for Sale | Amparo Jarquin REALTOR® West Palm Beach FL"
        description="Search Florida homes for sale with Amparo Jarquin, licensed REALTOR® in West Palm Beach FL. Expert guidance buying and selling real estate across all of Florida."
        keywords="Florida homes for sale, Florida real estate, West Palm Beach homes, buy home Florida, sell home Florida"
        canonical="/"
        ogImage="https://readdy.ai/api/search-image?query=aerial%20Florida%20coastal%20neighborhood%20homes%20palm%20trees%20blue%20ocean&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={homeSchema}
      />
      <Navbar />
      <HeroSection />
      <AmparoBio />
      <HomeCtaBanner />
      <Footer />
    </div>
  );
}
